export class MulticlientInfoItem {

    id: number;
    idGrupo: number;
    nombreGrupo: string;
    rango: number;
    fechaConcesion: Date;
    default: boolean;
    idCliente: number;
    nombreCliente: string;

    constructor() { }

    static toModel(json: string): MulticlientInfoItem {
        const data = JSON.parse(json);
        const toReturn = new MulticlientInfoItem();

        toReturn.id = data.Id;
        toReturn.idGrupo = data.ID_GRUPO;
        toReturn.nombreGrupo = data.NOMBRE_GRUPO;
        toReturn.rango = data.RANGO;
        toReturn.fechaConcesion = data.FECHA_CONCESION ? new Date(data.FECHA_CONCESION) : undefined;
        toReturn.default = data.DEFAULT;
        toReturn.idCliente = data.ID_CLIENT;
        toReturn.nombreCliente = data.NOMBRE_CLIENTE;

        return toReturn;
    }

}